import '../../assets/tailwind-compiled.css';
import './RegisterComponent.css';

import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FC, useEffect, useState} from 'react';

import {mainState} from '../../AppMainState';

import logoDark from '../../assets/images/logo_dark.svg';
import {Card} from '../../components/Card';
import {RegisterState} from './RegisterState';
import {LinkButton} from '../../components/LinkButton';
import {FormCheckbox} from '../../components/form/FormCheckbox';
import {SocialLogin} from '../../components/social-login/SocialLogin';
import {setTitle} from '../../routing/AppRouting';
import {AppRoutes} from '../../routing/AppRoutes';

export const RegisterComponent: FC = observer(() => {
    const [state] = useState(() => new RegisterState());

    useEffect(() => {
        setTitle('Registration');
    }, []);


    if (mainState.currentUser) {
        mainState.signOut();
        return <div/>;
    }


    return <div
        id="registration-wrapper"
        className="h-screen max-h-screen blur-overlay flex items-center justify-center px-6 py-5 w-full lg:px-10 lg:py-8"
    >
        <Card
            className="px-10"
            footer={
                <div className="flex justify-between">
                        <LinkButton to={AppRoutes.Login}>Do you have account? Log In here</LinkButton>
                    </div>
                }>
                <div className="flex justify-center py-6">
                    <a href="https://www.muscula.com"><img
                        className="w-56"
                        src={logoDark}
                        alt="Muscula logo"
                    /></a>
                </div>
                {/* <div className="border-b border-t border-m-gray-4 flex flex-col items-center mb-6">
                    <div className="p-4">NO CREDIT CARD REQUIRED!</div>
                    <div className="border-t border-m-gray-4 p-4">PLANS FROM <span className="text-m-green">$14</span> (INCL. VAT)</div>
                </div> */}
                <h2 className="mb-6 text-m-green">Register</h2>
                <form onSubmit={(e) => {
                    e.preventDefault();
                }}>
                    {/* <FormInput id='email' name='email' label='Enter your e-mail' value='' onChange={(e) => {state.setEmail(e)}}></FormInput> */}
                    <div className="form-group">
                        <label htmlFor="email">E-mail</label>
                        <input
                            className={'form-control'}
                            name="email"
                            aria-invalid={state.invalidData}
                            onChange={(e) => state?.setEmail(e.target.value)}
                            type="email"
                            maxLength={64}
                            value={state.email}
                        />
                        {state.invalidData && !state.email && <div className="invalid-feedback">
                            <div>
                                E-mail is required
                            </div>
                        </div>}
                    </div>
                    <div className="form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            aria-invalid={state.invalidData}
                            autoComplete="new-password"
                            maxLength={64}
                            onChange={(e) => state?.setPassword(e.target.value)}
                            className={'form-control'}/>
                        {!state.invalidData && <div className="text-xs">Longer than 12 chars</div>}
                        {state.invalidData && <div className="invalid-feedback">
                            {state.password.length === 0 && <div>
                                Password is required
                            </div>}
                            {state.password.length < 12 && <div>
                                Password must be at least 12 characters
                            </div>}
                        </div>}
                    </div>
                    <div className="form-group">
                        <label>Confirm Password</label>
                        <input
                            type="password"
                            aria-invalid={state.invalidData}
                            maxLength={50}
                            onChange={(e) => state?.setConfirmPassword(e.target.value)}
                            className={'form-control' + (state.invalidData ? ' is-invalid' : '')}/>
                        {state.invalidData &&
                            <div className="invalid-feedback">
                                {state.password !== state.confirmPassword && <div>
                                    Password's doesn't match
                                </div>}
                            </div>}
                    </div>
                    <FormCheckbox
                        id=""
                        name=""
                        checked={state.termsAccepted}
                        onChange={v => {
                            state?.setTermsAcceptance(v);
                        }}
                        label={
                            <span>I've read and accepted
                                <a href={'https://www.muscula.com/terms/'}
                                   target={'_blank'}
                                   rel="noopener noreferrer"
                                   className="text-m-green">
                                    &nbsp; the terms of service
                                </a>
                            </span>
                        }/>
                    <div className="flex form-group items-center justify-between">
                        <button
                            style={{height: 42}}
                            onClick={() => state?.register()}
                            className="btn btn-primary w-full"
                            disabled={mainState.isLoading}
                            type="submit"
                        >
                            {mainState.isLoading && <span className="spinner-border spinner-border-sm mr-1"/>}
                            Register
                        </button>
                    </div>
                    <div className="mt-6 card-footer p-0">
                        <div>
                            <SocialLogin title="Register with Google" state={state} register={true}/>
                        </div>
                    </div>
                </form>
            </Card>
        </div>;
    },
);
